/* eslint-disable react/prop-types */
import React from "react";
import { useParams } from "react-router-dom";
import { getArtworkWallet } from "../lib/api";
import dayjs from "dayjs";
import { Image, Spin } from "antd";
import TransactionTimeline from "../components/TransactionTimeline";

function stripHtml(html) {
  return html?.replace(/<[^>]*>/g, '') || '';
}

function InfoItem({ label, value }) {
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between border-b border-gray-100 pb-2">
      <h4 className="text-sm font-medium text-gray-500">{label}:</h4>
      <p className="text-base font-semibold text-gray-800">{value}</p>
    </div>
  );
}

const Profile = () => {
  const { id, artid } = useParams();

  const [wallet, setWallet] = React.useState(null);
  const [history, setHistory] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [fullRefund, setFullRefund] = React.useState(false);
  const [refundMessage, setRefundMessage] = React.useState("");

  React.useEffect(() => {
    const fetchWallet = async () => {
      try {
        const data = await getArtworkWallet(id, artid);
        console.log("Profile API Response:", data);

        setWallet(data.wallet);
        setHistory(data.history);
        setFullRefund(data.full_refund || false);
        setRefundMessage(data.message || "");
        setLoading(false);
      } catch (error) {
        console.error("Error fetching wallet data:", error);
        setLoading(false);
      }
    };

    fetchWallet();
  }, [id, artid]);

  return loading ? (
    <div className="flex items-center justify-center">
      <Spin size="large" />
    </div>
  ) : fullRefund ? (
    <div className="flex items-center justify-center min-h-[40vh]">
      <div className="text-center bg-red-50 border border-red-300 rounded-lg p-10 max-w-lg">
        <h2 className="text-2xl font-bold text-red-700 mb-2">
          {refundMessage || "Certificate no longer available"}
        </h2>
        <p className="text-gray-600">
          This certificate has been fully refunded and is no longer valid.
        </p>
      </div>
    </div>
  ) : !wallet ? (
    <div className="flex items-center justify-center">
      <div className="text-center">
        <h2 className="text-xl font-semibold text-gray-600 mb-2">
          Wallet not found
        </h2>
        <p className="text-gray-500">
          The specified wallet or artwork could not be found.
        </p>
      </div>
    </div>
  ) : (
    <div className="w-full mx-auto h-full">
      <div className="md:flex">
        <div className="hidden md:block md:w-1/3 h-64 md:h-auto">
          <Image
            src={
              import.meta.env.VITE_API_ADMIN_URL + "/" + wallet?.painting?.img
            }
            alt={wallet?.painting?.title?.en}
            className=""
          />
        </div>
        <div className="p-8 md:w-2/3">
          <h2 className="text-3xl font-extrabold text-gray-800 mb-6 border-b border-gray-200 pb-2">
            Wallet Information
          </h2>
          <Image
            src={
              import.meta.env.VITE_API_ADMIN_URL + "/" + wallet?.painting?.img
            }
            alt={wallet?.painting?.title?.en}
            className="block md:hidden"
          />
          <div className="space-y-4">
            <InfoItem label="Owner ID" value={wallet?.owner_id || "N/A"} />
            <InfoItem
              label="Owner Name"
              value={
                `${wallet?.owner_first_name || ""} ${wallet?.owner_last_name || ""}`.trim() ||
                "N/A"
              }
            />
            <InfoItem
              label="Last Transaction"
              value={
                wallet?.t ? dayjs(wallet.t).format("DD-MM-YYYY HH:mm") : "N/A"
              }
            />
            <InfoItem
              label="Painting Name"
              value={stripHtml(wallet?.painting?.title?.en) || "N/A"}
            />
            <InfoItem
              label="Artwork ID"
              value={wallet?.painting?.id || "N/A"}
            />
            <InfoItem
              label="Total Parts Owned"
              value={`${wallet?.quantity || 0} part(s)`}
            />
            <InfoItem
              label="Total Percentage Owned"
              value={`${wallet?.percentage || 0}%`}
            />
          </div>
        </div>
      </div>
      <TransactionTimeline transactions={history} />
    </div>
  );
};

export default Profile;
